<template>
  <div id="scanette">
    <p v-show="lastInputArray.length <= 0">
      En attente de scan<br><small>(scanette ou clavier)</small>
    </p>
    <p v-show="lastInputArray.length > 0">
      Dernier scan : <b>{{lastInputArray.join('')}}</b>
      <span v-show="message">{{message}}</span>
    </p>
  </div>
</template>

<script>
import server from '../../api/server.vue'
import {bus} from '../../core/utils/bus.js'

export default {
  name: 'ScanetteInput',
  data: function () {
    return {
      input: null,
      inputArray: [],
      message: "",
      lastInputArray: [],
    }
  },
  methods: {
    inputListener (event) {
      if (_.isEmpty(bus.currentStep)) {
        return
      }
      if (event.keyCode !== 13 && event.keyCode !== 16 ) {
        var newInput = this.inputArray.push(event.key)
      }
      else if (event.keyCode === 13) {
        this.inputArray = _.without(this.inputArray, "Alt")
        this.inputArray = _.without(this.inputArray, "Control")
        this.inputArray = _.without(this.inputArray, "Tab")
        
        var params = { 'code': this.inputArray.join(''), 'workstation': bus.currentStep.code }
        server.postNewCode(params).then((result) => {
          this.lastInputArray = this.inputArray
          this.inputArray = []
          this.$toasted.info(params.code +" Scanné !")
          this.$emit('new-scan', params.code)
          if('message' in result.data.scan_result && result.data.scan_result.message !== "") {
            this.message = result.data.scan_result.message
            this.$toasted.info(result.data.scan_result.message + " " + params.code)
          } else {
            this.message = ""
          }
        }).catch((error) => {
          this.lastInputArray = this.inputArray
          this.inputArray = []
          if(error.response == undefined)
            return
          if ( error.response.status != 415 && error.response.status != 413) {
            this.$toasted.error(params.code + " Erreur! " + error)
          }
          else if (error.response.status == 413) {
            this.$toasted.error(params.code + " : Une carte temporaire existe en stock. Veuillez scanner celle-ci.")
          }
        })
      }
    },
  },
  destroyed () {
    document.removeEventListener('keydown', this.inputListener)
  },
  mounted () {
    document.addEventListener('keydown', this.inputListener)
  },
};

</script>

<style>
#scanette {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 50px; /* minimum height */
  position: relative;
}
#scanette p {
  font-size: 1.2em;
  text-align: center;
  padding: 10px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/kanban/ScanetteInput.vue